export default __webpack_public_path__ + "static/media/Bracers of Celestial Radiance.866ec481.jpg";